import { Action } from "src/state/_types.js"
//import { setLanguageTag } from "src/locales/runtime.js"

export const setLocale: Action<'en'|'es'> = async ({state,actions}, locale) => {
    //setLanguageTag(locale)
    state.settings.locale = locale
    actions.saveSettings()
}